<template>
  <div class="gx-s1688 custom-el-wrapper">
    <!-- 页面标题 -->
    <div class="gx-s1688__hero">
      <div class="gx-s1688__hero-title">1688超级搜索</div>
      <div class="gx-s1688__hero-sub">批量关键词搜索，一键抓取1688商品</div>
    </div>

    <!-- 关键词配置卡片 -->
    <div class="gx-s1688__config-card">
      <div class="gx-s1688__config-main">
        <div class="gx-s1688__kw-header">
          <span class="gx-s1688__kw-title">关键词列表</span>
          <span class="gx-s1688__kw-count">共 <b>{{ keywordList.length }}</b> 个关键词</span>
        </div>
        <div class="gx-s1688__kw-textarea-box">
          <textarea
            v-model="keywordText"
            class="gx-s1688__kw-textarea"
            :placeholder="`每行输入一个关键词，例如：\nT恤男\n连衣裙女\n防晒衣`"
            @input="onKeywordInput"
          ></textarea>
        </div>
      </div>

      <div class="gx-s1688__config-side">
        <div class="gx-s1688__cfg-title">搜索配置</div>

        <div class="gx-s1688__cfg-row">
          <span class="gx-s1688__cfg-label">每词抓取数量</span>
          <div class="gx-s1688__cfg-input-wrap">
            <el-input-number
              v-model="searchConfig.perKeywordCount"
              :min="1"
              :max="100"
              :controls="false"
              size="mini"
              class="gx-s1688__cfg-number"
            />
            <span class="gx-s1688__cfg-unit">件/词</span>
          </div>
        </div>

        <div class="gx-s1688__cfg-row">
          <span class="gx-s1688__cfg-label">价格区间</span>
          <div class="gx-s1688__cfg-price">
            <span class="gx-s1688__cfg-price-symbol">¥</span>
            <el-input
              v-model.number="searchConfig.minPrice"
              placeholder="最低"
              size="mini"
              class="gx-s1688__cfg-price-input"
            />
            <span class="gx-s1688__cfg-price-sep">-</span>
            <span class="gx-s1688__cfg-price-symbol">¥</span>
            <el-input
              v-model.number="searchConfig.maxPrice"
              placeholder="最高"
              size="mini"
              class="gx-s1688__cfg-price-input"
            />
          </div>
        </div>

        <div class="gx-s1688__cfg-row">
          <span class="gx-s1688__cfg-label">排序方式</span>
          <el-select
            v-model="searchConfig.sortType"
            size="mini"
            class="gx-s1688__cfg-select"
          >
            <el-option label="综合排序" value="composite" />
            <el-option label="销量优先" value="sales" />
            <el-option label="价格从低到高" value="price_asc" />
            <el-option label="价格从高到低" value="price_desc" />
            <el-option label="上新时间" value="newest" />
          </el-select>
        </div>

        <div class="gx-s1688__cfg-row">
          <span class="gx-s1688__cfg-label">去重方式</span>
          <el-select
            v-model="searchConfig.dedupType"
            size="mini"
            class="gx-s1688__cfg-select"
          >
            <el-option label="不去重" value="none" />
            <el-option label="按商品ID去重" value="product_id" />
            <el-option label="按标题去重" value="title" />
          </el-select>
        </div>

        <div class="gx-s1688__cfg-row gx-s1688__cfg-row--switch">
          <span class="gx-s1688__cfg-label">自动加入云库</span>
          <el-switch
            v-model="searchConfig.autoAddCloud"
            size="mini"
            active-color="#D4A946"
          />
          <el-select
            v-if="searchConfig.autoAddCloud"
            v-model="searchConfig.cloudGroupId"
            size="mini"
            placeholder="选择云库分组"
            clearable
            class="gx-s1688__cfg-select gx-s1688__cfg-select--inline"
          >
            <el-option
              v-for="g in cloudGroupList"
              :key="g.id"
              :label="g.name"
              :value="g.id"
            />
          </el-select>
        </div>

        <div class="gx-s1688__cfg-actions">
          <button class="gx-s1688__btn-import">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M7 1v8m0 0l-3-3m3 3l3-3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 11v1a2 2 0 002 2h6a2 2 0 002-2v-1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
            </svg>
            <span>导入关键词</span>
            <input
              type="file"
              accept=".txt,.csv"
              style="display:none"
              @change="handleImportFile"
            />
          </button>
        </div>
      </div>
    </div>

    <!-- 操作按钮 -->
    <div class="gx-s1688__actions">
      <button
        class="gx-s1688__btn-primary"
        :disabled="searching || keywordList.length === 0"
        @click="startSearch"
      >
        <svg v-if="!searching" width="14" height="14" viewBox="0 0 14 14" fill="none">
          <circle cx="6" cy="6" r="4.5" stroke="currentColor" stroke-width="1.5"/>
          <path d="M10 10l3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <span v-if="searching">搜索中...</span>
        <span v-else>开始搜索</span>
      </button>
      <button class="gx-s1688__btn-clear" @click="clearAll">清空</button>
    </div>

    <!-- 搜索结果 -->
    <div v-if="hasSearched" class="gx-s1688__result">
      <div class="gx-s1688__result-header">
        <div class="gx-s1688__result-stat">
          搜索结果 共找到 <b>{{ pageData.total }}</b> 件商品
        </div>
        <div class="gx-s1688__result-ops">
          <label class="gx-s1688__check" @click="invertSelect">
            <div class="gx-s1688__check-box" :class="{ 'gx-s1688__check-box--on': isAllSelected }">
              <svg v-if="isAllSelected" width="8" height="8" viewBox="0 0 8 8" fill="none">
                <path d="M1 4l2 2 4-4" stroke="#F0F2F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span>全部选中/反选</span>
          </label>
<!--          <button class="gx-s1688__op-btn" @click="invertSelect">反选</button>-->
          <button
            class="gx-s1688__op-btn gx-s1688__op-btn--primary"
            :disabled="selectedRows.length === 0"
            @click="batchAddCloud"
          >+ 批量加入云商品库</button>
          <button class="gx-s1688__op-btn" @click="exportCSV">导出CSV</button>
          <button class="gx-s1688__op-btn gx-s1688__op-btn--danger" @click="clearResult">清空结果</button>
        </div>
      </div>

      <div class="gx-s1688__table-wrap">
        <table class="gx-s1688__table">
          <thead>
            <tr>
              <th class="gx-s1688__th gx-s1688__th--check">
                <label class="gx-s1688__check gx-s1688__check--sm">
                  <div class="gx-s1688__check-box" :class="{ 'gx-s1688__check-box--on': isAllCurrentPageSelected }">
                    <svg v-if="isAllCurrentPageSelected" width="8" height="8" viewBox="0 0 8 8" fill="none">
                      <path d="M1 4l2 2 4-4" stroke="#F0F2F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </label>
              </th>
              <th class="gx-s1688__th">商品图片</th>
              <th class="gx-s1688__th">商品标题</th>
              <th class="gx-s1688__th">价格</th>
              <th class="gx-s1688__th">1688链接</th>
              <th class="gx-s1688__th">关键词</th>
              <th class="gx-s1688__th">来源</th>
              <th class="gx-s1688__th gx-s1688__th--op">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="g in list"
              :key="g.id || g.product_id"
              class="gx-s1688__row"
            >
              <td class="gx-s1688__td gx-s1688__td--check">
                <label class="gx-s1688__check gx-s1688__check--sm">
                  <div class="gx-s1688__check-box" :class="{ 'gx-s1688__check-box--on': selectedRows.includes(g.id || g.product_id) }">
                    <svg v-if="selectedRows.includes(g.id || g.product_id)" width="8" height="8" viewBox="0 0 8 8" fill="none">
                      <path d="M1 4l2 2 4-4" stroke="#F0F2F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </label>
              </td>
              <td class="gx-s1688__td">
                <div class="gx-s1688__thumb" @click="goDetail(g)">
                  <img v-if="g.image || g.img" :src="g.image || g.img" alt="" />
                  <span v-else>🛍️</span>
                </div>
              </td>
              <td class="gx-s1688__td gx-s1688__td--title" @click="goDetail(g)">
                {{ g.title || g.name || '--' }}
              </td>
              <td class="gx-s1688__td gx-s1688__td--price">
                ¥{{ formatPrice(g.price || g.discount_price) }}
              </td>
              <td class="gx-s1688__td">
                <a
                  v-if="g.url || g.link"
                  :href="g.url || g.link"
                  target="_blank"
                  class="gx-s1688__link"
                >查看链接</a>
                <span v-else class="gx-s1688__link-empty">--</span>
              </td>
              <td class="gx-s1688__td">
                <span class="gx-s1688__kw-tag">{{ g.keyword || '--' }}</span>
              </td>
              <td class="gx-s1688__td">
                <span class="gx-s1688__source">{{ g.source || '1688' }}</span>
              </td>
              <td class="gx-s1688__td gx-s1688__td--op">
                <div class="gx-s1688__op-cell">
                  <a class="gx-s1688__detail-link" @click="goDetail(g)">详情</a>
                  <button
                    v-if="!g.in_cloud_library"
                    class="gx-s1688__btn-add-cloud"
                    :disabled="addingCloudIds.includes(g.id || g.product_id)"
                    @click="addCloudSingle(g)"
                  >加入云商品库</button>
                  <span v-else class="gx-s1688__added">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M2 6l3 3 5-6" stroke="#3FB6E0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    已加入
                  </span>
                </div>
              </td>
            </tr>
            <tr v-if="!list.length">
              <td colspan="8" class="gx-s1688__td gx-s1688__td--empty">
                暂无搜索结果
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 分页 -->
      <div class="gx-s1688__pager">
        <div class="gx-s1688__pager-total">
          <span>共 <b>{{ pageData.total }}</b> 条</span>
          <el-select size="mini" v-model="pageData.page_size" style="width: 100px" @change="search(1)">
            <el-option v-for="item in [20, 50, 100]" :key="item" :value="item" :label="item + '条/页'" />
          </el-select>
        </div>
        <div class="gx-s1688__pager-btns">
          <button class="gx-s1688__page" :disabled="pageData.page <= 1" @click="search(pageData.page - 1)">上一页</button>
          <template v-for="item in pagerItems">
            <button
              v-if="item.type === 'page'"
              :key="item.key"
              class="gx-s1688__page"
              :class="{ 'gx-s1688__page--on': item.value === pageData.page }"
              @click="search(item.value)"
            >{{ item.value }}</button>
            <button
              v-else
              :key="item.key"
              class="gx-s1688__page gx-s1688__page--more"
              @click="quickJump(item.dir)"
            >···</button>
          </template>
          <button class="gx-s1688__page" :disabled="pageData.page >= totalPages" @click="search(pageData.page + 1)">下一页</button>
        </div>
        <div class="gx-s1688__pager-jump">
          <span>前往</span>
          <input v-model="jumpPage" placeholder="页码" />
          <span>页</span>
          <button class="gx-s1688__jump-btn" @click="handleJump">确定</button>
        </div>
      </div>
    </div>

    <div v-else class="gx-s1688__empty-hint">
      <div class="gx-s1688__empty-icon">🔍</div>
      <div class="gx-s1688__empty-text">输入关键词开始搜索 1688 商品</div>
    </div>

    <!-- 加入云商品库弹窗 -->
    <div v-if="cloudGroupVisible" class="gx-modal" @click.self="cloudGroupVisible = false">
      <div class="gx-modal-box gx-modal-box--sm">
        <div class="gx-modal-head gx-modal-head--gray">
          <span class="gx-modal-title">加入云商品库</span>
          <button class="gx-modal-close" @click="cloudGroupVisible = false">✕</button>
        </div>
        <div class="gx-modal-body custom-form-wrap">
          <el-form size="small">
            <div class="gx-s1688__sel-tag">
              <span class="gx-s1688__sel-tag-dot"></span>
              <span>已选 {{ selectedRows.length }} 个商品</span>
            </div>
            <el-form-item label="选择分组">
              <el-select
                v-model="cloudGroupId"
                placeholder="不选择则不加入分组"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in cloudGroupList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="gx-modal-foot">
          <button class="gx-modal-foot-btn" @click="cloudGroupVisible = false">取消</button>
          <button
            class="gx-modal-foot-btn gx-modal-foot-btn--yellow"
            :disabled="cloudGroupLoading"
            @click="submitCloudGroup"
          >
            {{ cloudGroupLoading ? '保存中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 商品详情弹窗 -->
    <div v-if="detailVisible" class="gx-modal" @click.self="detailVisible = false">
      <div class="gx-s1688__detail-modal">
        <button class="gx-s1688__detail-close" @click="detailVisible = false">×</button>
        <div class="gx-s1688__detail-body">
          <div class="gx-s1688__detail-left">
            <div class="gx-s1688__detail-banner">
              <img v-if="bannerList[detailBannerIndex]" :src="bannerList[detailBannerIndex]" alt="" />
              <span v-else>🛍️</span>
            </div>
            <div v-if="bannerList.length > 1" class="gx-s1688__detail-thumbs">
              <div
                v-for="(item, idx) in bannerList"
                :key="idx"
                class="gx-s1688__detail-thumb"
                :class="{ 'gx-s1688__detail-thumb--on': idx === detailBannerIndex }"
                @click="detailBannerIndex = idx"
              >
                <img :src="item" alt="" />
              </div>
            </div>
          </div>
          <div class="gx-s1688__detail-right">
            <div class="gx-s1688__detail-title">{{ productData.title || productData.name || '--' }}</div>
            <div class="gx-s1688__detail-price">¥{{ formatPrice(productData.price || productData.discount_price) }}</div>
            <div class="gx-s1688__detail-meta">
              <span>关键词：{{ productData.keyword || '--' }}</span>
              <span>来源：{{ productData.source || '1688' }}</span>
            </div>
            <div v-if="productData.url || productData.link" class="gx-s1688__detail-link-row">
              <a :href="productData.url || productData.link" target="_blank" class="gx-s1688__link">打开原链接 ↗</a>
            </div>
          </div>
        </div>
        <div class="gx-s1688__detail-foot">
          <button
            v-if="!productData.in_cloud_library"
            class="gx-s1688__btn-add-cloud gx-s1688__btn-add-cloud--lg"
            :disabled="detailAddingCloud"
            @click="addCloudFromDetail"
          >加入云商品库</button>
          <span v-else class="gx-s1688__added">
            <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
              <path d="M2 6l3 3 5-6" stroke="#3FB6E0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            已加入云商品库
          </span>
          <button class="gx-s1688__btn-cancel" @click="detailVisible = false">关闭</button>
        </div>
      </div>
    </div>

    <under-development ref="underDevelopmentRef"></under-development>
  </div>
</template>

<script>
import UnderDevelopment from "@/components/newUi/UnderDevelopment.vue";
import { addToCloudProduct } from '@/api/main/index'
import { cloudProductGroups } from '@/api/main/ucenter'

export default {
  name: 'SelectGoods1688Page',
  components:{UnderDevelopment},
  data() {
    return {
      keywordText: '',
      keywordList: [],
      searching: false,
      hasSearched: false,
      searchConfig: {
        perKeywordCount: 20,
        minPrice: null,
        maxPrice: null,
        sortType: 'composite',
        dedupType: 'none',
        autoAddCloud: false,
        cloudGroupId: null
      },
      list: [],
      pageData: { page: 1, page_size: 20, total: 0 },
      jumpPage: '',
      selectedRows: [],
      addingCloudIds: [],
      cloudGroupList: [],
      cloudGroupVisible: false,
      cloudGroupId: null,
      cloudGroupLoading: false,
      cloudGroupLoaded: false,
      // 详情弹窗
      detailVisible: false,
      productData: {},
      bannerList: [],
      detailBannerIndex: 0,
      detailAddingCloud: false
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.pageData.total / this.pageData.page_size))
    },
    pagerItems() {
      const total = this.totalPages
      const current = this.pageData.page
      const pagerCount = 7
      if (total <= pagerCount) {
        return Array.from({ length: total }, (_, i) => ({ type: 'page', value: i + 1, key: 'p' + (i + 1) }))
      }
      const showPrevMore = current > pagerCount - 2
      const showNextMore = current < total - 3
      const middles = []
      if (showPrevMore && showNextMore) {
        for (let i = current - 2; i <= current + 2; i++) middles.push(i)
      } else if (showPrevMore) {
        for (let i = total - (pagerCount - 2); i < total; i++) middles.push(i)
      } else if (showNextMore) {
        for (let i = 2; i < pagerCount; i++) middles.push(i)
      } else {
        for (let i = 2; i < total; i++) middles.push(i)
      }
      const items = [{ type: 'page', value: 1, key: 'p1' }]
      if (showPrevMore) items.push({ type: 'more', dir: 'prev', key: 'more-prev' })
      middles.forEach(n => items.push({ type: 'page', value: n, key: 'p' + n }))
      if (showNextMore) items.push({ type: 'more', dir: 'next', key: 'more-next' })
      items.push({ type: 'page', value: total, key: 'pt' + total })
      return items
    },
    isAllCurrentPageSelected() {
      return this.list.length > 0 && this.list.every(i => this.selectedRows.includes(i.id || i.product_id))
    },
    isAllSelected() {
      // return this.hasSearched && this.pageData.total > 0 && this.selectedRows.length === this.pageData.total
      return this.hasSearched && this.list.length > 0 && this.selectedRows.length === this.list.length
    }
  },
  mounted() {
    this.$nextTick(this.$refs.underDevelopmentRef.show)
    this.loadCloudGroupList()
  },
  methods: {
    onKeywordInput() {
      this.keywordList = this.keywordText
        .split(/\r?\n/)
        .map(k => k.trim())
        .filter(k => k)
    },
    handleImportFile(e) {
      const file = e.target.files[0]
      if (!file) return
      const reader = new FileReader()
      reader.onload = (ev) => {
        const text = ev.target.result || ''
        const keywords = text
          .split(/[\r\n,，;；]+/)
          .map(k => k.trim())
          .filter(k => k)
        const merged = [...new Set([...this.keywordList, ...keywords])]
        this.keywordList = merged
        this.keywordText = merged.join('\n')
        this.$message.success(`导入 ${keywords.length} 个关键词`)
      }
      reader.readAsText(file)
      e.target.value = ''
    },
    startSearch() {
      if (this.keywordList.length === 0) {
        this.$message.warning('请输入至少一个关键词')
        return
      }
      this.search(1)
    },
    clearAll() {
      this.keywordText = ''
      this.keywordList = []
      this.list = []
      this.pageData.total = 0
      this.selectedRows = []
      this.hasSearched = false
    },
    clearResult() {
      this.list = []
      this.pageData.total = 0
      this.selectedRows = []
      this.hasSearched = false
    },
    search(page) {
      this.searching = true
      this.pageData.page = page
      // TODO: 接入真实 1688 超级搜索 API
      // 目前使用 mock 数据演示界面
      setTimeout(() => {
        const mockData = this.generateMockData()
        this.list = mockData.list
        this.pageData.total = mockData.total
        this.hasSearched = true
        this.searching = false
      }, 800)
    },
    generateMockData() {
      const titles = [
        '2024夏季新款T恤男短袖宽松圆领纯色体恤上衣',
        '男士休闲短袖t恤夏季潮流百搭半袖上衣',
        '冰丝速干T恤男士夏季薄款透气运动短袖',
        '女士连衣裙2024新款法式气质显瘦收腰裙',
        '碎花连衣裙女夏季小个子显瘦A字裙'
      ]
      const images = ['👕', '👔', '🧥', '👗', '🌸']
      const total = 123
      const start = (this.pageData.page - 1) * this.pageData.page_size
      const list = Array.from({ length: Math.min(this.pageData.page_size, total - start) }, (_, i) => {
        const idx = (start + i) % titles.length
        return {
          id: `1688_${start + i + 1}`,
          title: titles[idx],
          image: null,
          img: null,
          emoji: images[idx],
          price: (10 + Math.random() * 50).toFixed(2),
          url: `https://detail.1688.com/offer/${100000 + start + i}.html`,
          keyword: this.keywordList[(start + i) % this.keywordList.length],
          source: '1688',
          in_cloud_library: Math.random() > 0.6
        }
      })
      return { list, total }
    },
    invertSelect() {
      const currentIds = this.list.map(i => i.id || i.product_id)
      const others = this.selectedRows.filter(id => !currentIds.includes(id))
      const flipped = currentIds.filter(id => !this.selectedRows.includes(id))
      this.selectedRows = [...others, ...flipped]
    },
    batchAddCloud() {
      this.$message.warning('功能开发中，敬请期待')
      return;
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先勾选商品')
        return
      }
      this.cloudGroupId = null
      this.cloudGroupVisible = true
    },
    loadCloudGroupList() {
      if (this.cloudGroupLoaded) return
      cloudProductGroups({}).then(res => {
        if (res.code === 200) {
          this.cloudGroupList = res.data || []
          this.cloudGroupLoaded = true
        }
      }).catch(() => {})
    },
    submitCloudGroup() {
      this.cloudGroupLoading = true
      const params = { product_ids: this.selectedRows }
      if (this.cloudGroupId) params.group_id = this.cloudGroupId
      addToCloudProduct(params).then(res => {
        this.cloudGroupLoading = false
        if (res.code === 200) {
          this.$message.success(res.message || '加入成功')
          this.cloudGroupVisible = false
          this.list.forEach(g => {
            if (this.selectedRows.includes(g.id || g.product_id)) g.in_cloud_library = true
          })
        } else {
          this.$message.error(res.message || '加入失败')
        }
      }).catch(() => { this.cloudGroupLoading = false })
    },
    addCloudSingle(g) {
      this.$message.warning('功能开发中，敬请期待')
      return;
      const id = g.id || g.product_id
      if (this.addingCloudIds.includes(id)) return
      this.addingCloudIds.push(id)
      addToCloudProduct({ product_ids: [id] }).then(res => {
        this.addingCloudIds = this.addingCloudIds.filter(i => i !== id)
        if (res.code === 200) {
          this.$message.success(res.message || '加入成功')
          g.in_cloud_library = true
        } else {
          this.$message.error(res.message || '加入失败')
        }
      }).catch(() => {
        this.addingCloudIds = this.addingCloudIds.filter(i => i !== id)
      })
    },
    addCloudFromDetail() {
      const id = this.productData.id || this.productData.product_id
      if (!id || this.detailAddingCloud) return
      this.detailAddingCloud = true
      addToCloudProduct({ product_ids: [id] }).then(res => {
        this.detailAddingCloud = false
        if (res.code === 200) {
          this.$message.success(res.message || '加入成功')
          this.productData.in_cloud_library = true
          const row = this.list.find(i => (i.id || i.product_id) === id)
          if (row) row.in_cloud_library = true
        } else {
          this.$message.error(res.message || '加入失败')
        }
      }).catch(() => { this.detailAddingCloud = false })
    },
    exportCSV() {
      const rows = [['商品标题', '价格', '1688链接', '关键词', '来源']]
      this.list.forEach(g => {
        rows.push([
          g.title || g.name || '',
          g.price || g.discount_price || '',
          g.url || g.link || '',
          g.keyword || '',
          g.source || '1688'
        ])
      })
      const csv = rows.map(r => r.map(c => `"${String(c).replace(/"/g, '""')}"`).join(',')).join('\n')
      const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `1688_search_${Date.now()}.csv`
      a.click()
      URL.revokeObjectURL(url)
      this.$message.success('导出成功')
    },
    goDetail(g) {
      this.productData = { ...g }
      this.bannerList = g.image || g.img ? [g.image || g.img] : []
      this.detailBannerIndex = 0
      this.detailVisible = true
    },
    handleJump() {
      const num = Math.floor(Number(this.jumpPage))
      if (!num || num < 1) return
      const current = num > this.totalPages ? this.totalPages : num
      this.jumpPage = ''
      this.search(current)
    },
    quickJump(dir) {
      const target = dir === 'prev'
        ? Math.max(1, this.pageData.page - 5)
        : Math.min(this.totalPages, this.pageData.page + 5)
      if (target !== this.pageData.page) this.search(target)
    },
    formatPrice(p) {
      if (p == null || p === '') return '0.00'
      const n = Number(p)
      return isNaN(n) ? p : n.toFixed(2)
    }
  }
}
</script>

<style scoped>
.gx-s1688 {
  font-family: 'Noto Sans SC', sans-serif;
  color: #4A4A6A;
}

/* ---- 标题 ---- */
.gx-s1688__hero {
  margin-bottom: 20px;
}
.gx-s1688__hero-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 26px;
  font-weight: 700;
  color: #1A1A2E;
}
.gx-s1688__hero-sub {
  font-size: 14px;
  color: #4a4a6a;
  margin-top: 6px;
}

/* ---- 配置卡片 ---- */
.gx-s1688__config-card {
  background: #FFFFFF;
  overflow: hidden;
  backdrop-filter: none;
  border: 1px solid rgb(224, 224, 236);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 24px;
}
.gx-s1688__config-main {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.gx-s1688__kw-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.gx-s1688__kw-title {
  font-size: 14px;
  color: #1A1A2E;
}
.gx-s1688__kw-count {
  font-size: 12px;
  color: #6A6A8A;
}
.gx-s1688__kw-count b {
  color: #D4A946;
  font-weight: 700;
}
.gx-s1688__kw-textarea-box{
  min-height: 0;
  flex: 1;
}
.gx-s1688__kw-textarea {
  width: 100%;
  height: 100%;
  padding: 12px 14px;
  border-radius: 8px;
  resize: vertical;
  background: rgb(255, 255, 255);
  border: 1px solid rgba(255, 255, 255, 0.1);
  font-family: "JetBrains Mono", monospace;
  font-size: 13px;
  color: rgb(26, 26, 46);
  line-height: 1.8;
  outline: none;
  transition: border 0.2s;
  box-sizing: border-box;
}
.gx-s1688__kw-textarea:focus {
  border:1px solid rgba(212, 169, 70, 0.65);
}
.gx-s1688__kw-textarea::placeholder {
  color: #B0B8C8;
}

.gx-s1688__config-side {
  display: flex;
  flex-direction: column;
}
.gx-s1688__cfg-title {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: rgb(26, 26, 46);
  margin-bottom: 16px;
}
.gx-s1688__cfg-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}
.gx-s1688__cfg-row--switch {
  flex-wrap: wrap;
}
.gx-s1688__cfg-label {
  font-size: 13px;
  color: var(--gx-black);
  white-space: nowrap;
  min-width: 100px;
  text-align: right;
}
.gx-s1688__cfg-input-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}
.gx-s1688__cfg-number {
  width: 80px;
}
.gx-s1688__cfg-number >>> .el-input__inner {
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: var(--gx-gold);
}
.gx-s1688__cfg-unit {
  font-size: 13px;
  color: rgb(74, 74, 106);
}
.gx-s1688__cfg-price {
  display: flex;
  align-items: center;
  gap: 6px;
}
.gx-s1688__cfg-price-symbol {
  color: #D4A946;
  font-size: 12px;
}
.gx-s1688__cfg-price-input {
  width: 80px;
}
.gx-s1688__cfg-price-input >>> .el-input__inner {
  height: 32px;
  line-height: 32px;
  font-size: 13px;
  color: var(--gx-black);
}
.gx-s1688__cfg-price-sep {
  color: #B0B8C8;
}
.gx-s1688__cfg-select {
  width: 140px;
}
.gx-s1688__cfg-select--inline {
  width: 140px;
  /*margin-left: auto;*/
}
.gx-s1688__cfg-select >>> .el-input__inner {
  height: 32px;
  line-height: 32px;
  font-size: 13px;
  color: var(--gx-black);
}
.gx-s1688__cfg-actions {
  margin-top: auto;
  padding-top: 12px;
}
.gx-s1688__btn-import {
  height: 34px;
  padding: 0 16px;
  border-radius: 6px;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  font-weight: 400;
  background: transparent;
  border: 1px solid rgba(63, 182, 224, 0.4);
  color: rgb(63, 182, 224);
  opacity: 1;
  transition: 0.2s;
  white-space: nowrap;
}
.gx-s1688__btn-import:hover {
  border-color: #D4A946;
  color: #D4A946;
}

/* ---- 操作按钮 ---- */
.gx-s1688__actions {
  background: rgb(255, 255, 255);
  backdrop-filter: none;
  border: 1px solid rgb(224, 224, 236);
  border-radius: 12px;
  padding: 14px 20px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.gx-s1688__btn-primary {
  height: 36px;
  padding: 0 24px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #D4A946, #E8C778);
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
}
.gx-s1688__btn-primary:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(212, 169, 70, 0.35);
}
.gx-s1688__btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.gx-s1688__btn-clear {
  height: 36px;
  padding: 0 18px;
  border: 1px solid #DDE2EC;
  border-radius: 8px;
  background: #FFFFFF;
  color: #6A6A8A;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}
.gx-s1688__btn-clear:hover {
  border-color: #4A4A6A;
  color: #1A1A2E;
}

/* ---- 结果区 ---- */
.gx-s1688__result {
  background: #FFFFFF;
  border: 1px solid #DDE2EC;
  border-radius: 10px;
  box-shadow: rgba(15, 23, 42, 0.04) 0px 1px 4px;
  overflow: hidden;
}
.gx-s1688__result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #EEF1F6;
  background: #FAFBFD;
}
.gx-s1688__result-stat {
  font-size: 13px;
  color: #4A4A6A;
}
.gx-s1688__result-stat b {
  color: #D4A946;
  font-weight: 700;
}
.gx-s1688__result-ops {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gx-s1688__op-btn {
  height: 28px;
  padding: 0 12px;
  border: 1px solid #DDE2EC;
  border-radius: 6px;
  background: #FFFFFF;
  color: #4A4A6A;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}
.gx-s1688__op-btn:hover {
  border-color: #1A1A2E;
}
.gx-s1688__op-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.gx-s1688__op-btn--primary {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border: none;
  color: #FFFFFF;
  font-weight: 600;
}
.gx-s1688__op-btn--primary:hover:not(:disabled) {
  box-shadow: 0 2px 8px rgba(212, 169, 70, 0.3);
}
.gx-s1688__op-btn--danger {
  color: #D66D6D;
}
.gx-s1688__op-btn--danger:hover {
  border-color: #D66D6D;
  background: #FFF5F5;
}

/* ---- 复选框 ---- */
.gx-s1688__check {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
  color: #4A4A6A;
}
.gx-s1688__check--sm {
  font-size: inherit;
}
.gx-s1688__check-box {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  background: #FFFFFF;
  border: 1.5px solid #DDE2EC;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-shrink: 0;
  transition: all 0.15s;
}
.gx-s1688__check-box--on {
  border-color: transparent;
  background: linear-gradient(135deg, #D4A946, #E8C778);
}

/* ---- 表格 ---- */
.gx-s1688__table-wrap {
  overflow-x: auto;
}
.gx-s1688__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.gx-s1688__th {
  padding: 10px 12px;
  text-align: left;
  font-weight: 600;
  color: #4A4A6A;
  background: #F3F5FA;
  border-bottom: 1px solid #DDE2EC;
  white-space: nowrap;
  font-size: 12px;
}
.gx-s1688__th--check {
  width: 40px;
}
.gx-s1688__th--op {
  width: 180px;
}
.gx-s1688__td {
  padding: 12px;
  border-bottom: 1px solid #EEF1F6;
  vertical-align: middle;
}
.gx-s1688__td--check {
  width: 40px;
}
.gx-s1688__td--title {
  max-width: 260px;
  color: #1A1A2E;
  cursor: pointer;
  line-height: 1.5;
}
.gx-s1688__td--title:hover {
  color: #D4A946;
}
.gx-s1688__td--price {
  font-family: 'JetBrains Mono', monospace;
  color: #D4A946;
  font-weight: 600;
  white-space: nowrap;
}
.gx-s1688__td--op {
  width: 180px;
}
.gx-s1688__td--empty {
  text-align: center;
  padding: 60px 20px;
  color: #B0B8C8;
  font-size: 13px;
}
.gx-s1688__row:hover {
  background: #FAFBFD;
}

/* 缩略图 */
.gx-s1688__thumb {
  width: 52px;
  height: 52px;
  border-radius: 6px;
  background: #F3F5FA;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
  font-size: 24px;
}
.gx-s1688__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.gx-s1688__link {
  color: #3FB6E0;
  text-decoration: none;
  cursor: pointer;
  font-size: 12px;
}
.gx-s1688__link:hover {
  text-decoration: underline;
}
.gx-s1688__link-empty {
  color: #B0B8C8;
}

.gx-s1688__kw-tag {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 3px;
  background: rgba(212, 169, 70, 0.1);
  border: 1px solid rgba(212, 169, 70, 0.25);
  color: #D4A946;
  font-size: 11px;
}

.gx-s1688__source {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 3px;
  background: #F3F5FA;
  color: #6A6A8A;
  font-size: 11px;
}

/* 操作列 */
.gx-s1688__op-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.gx-s1688__detail-link {
  color: #3FB6E0;
  cursor: pointer;
  font-size: 12px;
  flex-shrink: 0;
}
.gx-s1688__detail-link:hover {
  text-decoration: underline;
}
.gx-s1688__btn-add-cloud {
  height: 26px;
  padding: 0 12px;
  border: none;
  border-radius: 4px;
  background: linear-gradient(135deg, #D4A946, #E8C778);
  color: #FFFFFF;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.gx-s1688__btn-add-cloud:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.gx-s1688__btn-add-cloud:hover:not(:disabled) {
  box-shadow: 0 2px 6px rgba(212, 169, 70, 0.3);
}
.gx-s1688__btn-add-cloud--lg {
  height: 34px;
  padding: 0 20px;
  font-size: 12px;
}
.gx-s1688__added {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 4px;
  background: rgba(63, 182, 224, 0.1);
  color: #3FB6E0;
  font-size: 11px;
}

/* ---- 分页 ---- */
.gx-s1688__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-top: 1px solid #EEF1F6;
  font-size: 12px;
  color: #4A4A6A;
}
.gx-s1688__pager-total {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gx-s1688__pager-total b {
  color: #D4A946;
}
.gx-s1688__pager-btns {
  display: flex;
  gap: 5px;
}
.gx-s1688__page {
  min-width: 28px;
  height: 28px;
  padding: 0 10px;
  border-radius: 4px;
  border: 1px solid #DDE2EC;
  background: #FFFFFF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: #4A4A6A;
  transition: all 0.15s;
  box-sizing: border-box;
}
.gx-s1688__page:hover:not(:disabled) {
  border-color: #D4A946;
  color: #D4A946;
}
.gx-s1688__page:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.gx-s1688__page--on {
  border-color: #D4A946;
  background: #FAF5E8;
  color: #D4A946;
}
.gx-s1688__page--more {
  border-color: transparent;
  background: transparent;
}
.gx-s1688__page--more:hover {
  border-color: transparent;
  color: #D4A946;
}
.gx-s1688__pager-jump {
  display: flex;
  align-items: center;
  gap: 6px;
}
.gx-s1688__pager-jump input {
  width: 48px;
  height: 28px;
  padding: 0 6px;
  border-radius: 4px;
  border: 1px solid #DDE2EC;
  background: #FFFFFF;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: #1A1A2E;
  outline: none;
  text-align: center;
  box-sizing: border-box;
}
.gx-s1688__jump-btn {
  height: 28px;
  padding: 0 12px;
  border-radius: 4px;
  border: 1px solid #D4A946;
  background: #FAF5E8;
  cursor: pointer;
  font-size: 12px;
  color: #D4A946;
  transition: all 0.15s;
}
.gx-s1688__jump-btn:hover {
  background: #D4A946;
  color: #FFFFFF;
}

/* ---- 空提示 ---- */
.gx-s1688__empty-hint {
  text-align: center;
  padding: 80px 20px;
}
.gx-s1688__empty-icon {
  font-size: 48px;
  margin-bottom: 12px;
}
.gx-s1688__empty-text {
  color: #B0B8C8;
  font-size: 13px;
}

/* ---- 加入云库弹窗 ---- */
.gx-s1688__sel-tag {
  width: max-content;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 4px;
  background: #FFF8E6;
  border: 1px solid rgba(212, 169, 70, 0.4);
  font-size: 11px;
  color: #D4A946;
  font-weight: 500;
  margin-bottom: 12px;
}
.gx-s1688__sel-tag-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #D4A946;
}

/* ---- 详情弹窗 ---- */
.gx-s1688__detail-modal {
  width: 720px;
  max-height: 80vh;
  border-radius: 12px;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.15) 0 20px 50px;
}
.gx-s1688__detail-close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.06);
  cursor: pointer;
  color: #6A6A8A;
  font-size: 18px;
  transition: all 0.2s;
}
.gx-s1688__detail-close:hover {
  background: rgba(214, 109, 109, 0.15);
  color: #D66D6D;
}
.gx-s1688__detail-body {
  display: flex;
  flex: 1;
  overflow: hidden;
}
.gx-s1688__detail-left {
  width: 320px;
  padding: 20px;
  border-right: 1px solid #EEF1F6;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.gx-s1688__detail-banner {
  width: 100%;
  height: 260px;
  border-radius: 8px;
  background: #F3F5FA;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-size: 64px;
}
.gx-s1688__detail-banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-s1688__detail-thumbs {
  display: flex;
  gap: 6px;
  overflow-x: auto;
}
.gx-s1688__detail-thumb {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  overflow: hidden;
  background: #F3F5FA;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.2s;
  flex-shrink: 0;
}
.gx-s1688__detail-thumb--on {
  border-color: #D4A946;
}
.gx-s1688__detail-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-s1688__detail-right {
  flex: 1;
  padding: 24px 20px;
  overflow-y: auto;
}
.gx-s1688__detail-title {
  font-size: 16px;
  font-weight: 600;
  color: #1A1A2E;
  line-height: 1.5;
  margin-bottom: 12px;
  padding-right: 36px;
}
.gx-s1688__detail-price {
  font-family: 'JetBrains Mono', monospace;
  font-size: 24px;
  font-weight: 700;
  color: #D4A946;
  margin-bottom: 16px;
}
.gx-s1688__detail-meta {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;
  color: #6A6A8A;
  padding: 12px;
  background: #FAFBFD;
  border-radius: 6px;
  margin-bottom: 12px;
}
.gx-s1688__detail-link-row {
  padding-top: 8px;
  border-top: 1px solid #EEF1F6;
}
.gx-s1688__detail-foot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #EEF1F6;
  background: #FAFBFD;
}
.gx-s1688__btn-cancel {
  height: 34px;
  padding: 0 20px;
  border: 1px solid #DDE2EC;
  border-radius: 6px;
  background: #FFFFFF;
  color: #4A4A6A;
  font-size: 12px;
  cursor: pointer;
}
.gx-s1688__btn-cancel:hover {
  border-color: #4A4A6A;
}

/* ---- Element UI 覆盖 ---- */
.custom-el-wrapper >>> .el-input__inner,
.custom-el-wrapper >>> .el-textarea__inner {
  border-radius: 6px;
}
.custom-el-wrapper >>> .el-input__inner:focus,
.custom-el-wrapper >>> .el-textarea__inner:focus {
  border-color: rgba(212, 169, 70, 0.65);
}
.custom-el-wrapper >>> .el-input-number {
  line-height: 24px;
}
.custom-el-wrapper >>> .el-switch.is-checked .el-switch__core {
  border-color: #D4A946;
  background-color: #D4A946;
}
</style>
